// extracted by mini-css-extract-plugin
export const eventDateTag = "event-date-tag-module--eventDateTag--2aaP7";
export const pastEvent = "event-date-tag-module--pastEvent--25T5O";
export const eventDateBg = "event-date-tag-module--eventDateBg--3Xjf3";
export const eventDateTagSmall = "event-date-tag-module--eventDateTagSmall--2wPOS";
export const eventDate = "event-date-tag-module--eventDate--GlsEL";
export const dateMonth = "event-date-tag-module--dateMonth--1li_8";
export const dateDay = "event-date-tag-module--dateDay--23Kcc";
export const dateContent = "event-date-tag-module--dateContent--3d3GQ";